import React, { useState, useEffect } from 'react'
import DataTable from '../Shared/DataTable/DataTable.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import ItemDetailsPane from './ItemDetailsPane.js'
import AddItemPopup from './AddItemPopup.js'
import LoadingSpinnerImage from '../Shared/LoadingSpinnerImage.js'

const ENTITY_TYPE_ID = 18;

const TechnicalDocumentation = () => {

    const [isLoadingStructure, setIsLoadingStructure] = useState(true);
    const [errorLoadingStructure, setErrorLoadingStructure] = useState(false);
    const [dataTableStructure, setDataTableStructure] = useState({});

    let config = {};
    config.dataUrl = "/umbraco/api/Compliance/TechnicalDocumentation";
    config.getSingleItemUrl = "/umbraco/api/Compliance/TechnicalDocument";
    config.pageTitle = "Technical Documentation";
    config.singleItemTitle = "Technical Documentation Reference & Title";
    config.entityType = "compliance-technical-documents";
    config.entityTypeId = ENTITY_TYPE_ID;
    config.pageIcon = "fas fa-book";
    config.breadcrumbs = [
        { "Name": "Compliance Manager", "Link": "/your-medboard/compliance-portfolio/" },
        { "Name": "Technical Documentation", "Link": "/your-medboard/compliance-portfolio/technical-documentation/" }
    ];
    config.dataStructure = [];
    config.ComplianceType = "TechnicalDocumentation";
    config.enableCustomFields = true;
    config.preLoadItemUrlParamName = "viewItemId";
    config.preLoadItemId = window.preloadTechnicalDocumentationId;
    config.showTaskCount = true;
    config.showCMArchiveFilter = true;
    config.showTotalAndFilteredCounts = true;
    config.dataUrlParameters = { search: null, page: 1, orderByField: "Name", orderByType: "ASCENDING" };

    useEffect(() => { loadStructure(); }, []);

    const loadStructure = () => {
        setIsLoadingStructure(true);
        setErrorLoadingStructure(false);

        fetch("/umbraco/api/CustomFields/Headers/?entityType=" + config.entityTypeId, { method: 'GET' })
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) document.dispatchEvent(new Event("api:unauthorized"));
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {
                (result || []).forEach((column) => {
                    config.dataStructure.push({
                        customFieldId: column.CustomFieldId,
                        customFieldType: column.CustomFieldType,
                        name: column.Name,
                        field: column.Field,
                        width: column.Width,
                        sortable: column.Sortable,
                        isSelectItemCheckbox: column.IsSelectItemCheckbox,
                        renderWith: FieldTypes[column.RenderWith] ?? FieldTypes.FieldType_Text,
                        isMultiField: column.IsMultiField,
                        hasFilter: !!column.HasFilter,
                    });
                });
                // fall back to a fixed 3-column layout if no resolver headers came back
                if (config.dataStructure.length === 0) {
                    config.dataStructure.push({ name: "Reference & Title", field: "Name", width: "57%", sortable: true, renderWith: FieldTypes.FieldType_MainText });
                    config.dataStructure.push({ name: "Compliance Status", field: "Status", width: "29%", renderWith: FieldTypes.FieldType_Compliance_Status });
                    config.dataStructure.push({ name: "Open Tasks", field: "TaskCount", width: "14%", sortable: true, renderWith: FieldTypes.FieldType_Open_Tasks });
                }
                setDataTableStructure(config);
                setIsLoadingStructure(false);
            })
            .catch(() => {
                setErrorLoadingStructure(true);
                setIsLoadingStructure(false);
            });
    };

    if (isLoadingStructure) return <div style={{ padding: 40, textAlign: "center" }}><LoadingSpinnerImage /></div>;
    if (errorLoadingStructure) return <div style={{ padding: 40 }}>Could not load the table layout. Please refresh.</div>;

    return (
        <DataTable
            dataTableStructure={dataTableStructure}
            ItemDetailsPane={ItemDetailsPane}
            AddItemPopup={AddItemPopup}
            ReloadStructureFunction={loadStructure}
        />
    );
};

export default TechnicalDocumentation;
